import type { IImmunizationInfo } from 'src/interfaces/family'
import {
  getImmunizationRecordStatus,
  type ImmunizationRecordStatus,
} from 'src/utils/immunizationStatus'

export const vaccinationTrackingConfigurationPath =
  'features.vaccinationTracking'

export function getImmunizationReportColumnLabel(
  enableVaccinationTracking: boolean,
) {
  return enableVaccinationTracking
    ? 'Vaccination Status'
    : 'Immunizations Up To Date'
}

export type OverallVaccinationStatus =
  | 'Complete'
  | 'Complete/Exempt'
  | 'Exempt'
  | 'Overdue'
  | 'Missing Info'
  | 'Overdue/Missing Info'

export function getOverallVaccinationStatus(
  immunizationInfo?: IImmunizationInfo,
): OverallVaccinationStatus {
  const statuses =
    immunizationInfo?.immunizationRecord?.map((record) =>
      getImmunizationRecordStatus(record),
    ) ?? []

  if (statuses.length === 0) return 'Missing Info'

  return getOverallVaccinationStatusFromRecordStatuses(statuses)
}

export function getOverallVaccinationStatusFromRecordStatuses(
  statuses: ImmunizationRecordStatus[],
): OverallVaccinationStatus {
  const hasOverdue = statuses.includes('Overdue')
  const hasMissingInfo = statuses.includes('Missing Info')

  if (hasOverdue && hasMissingInfo) return 'Overdue/Missing Info'
  if (hasOverdue) return 'Overdue'
  if (hasMissingInfo) return 'Missing Info'

  const hasComplete = statuses.includes('Complete')
  const hasExempt = statuses.includes('Exempt')

  if (hasComplete && hasExempt) return 'Complete/Exempt'
  if (hasExempt) return 'Exempt'

  return 'Complete'
}
